import { ColorPalette } from '../soho/ColorPalette';

export default `
  .markdown-body {
      color: inherit;
  }

  .markdown-body .highlight pre,
  .markdown-body pre {
    background-color: ${ColorPalette.$slate10};
  }
`